import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../../../utils/withRouter";
import Loader from "../../../../utils/Loader";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { getAdminSeminarSummaryList_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_summary_action/admin_dashboard_summary_action";

class ConferenceSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      seminarSummaryList: [],
    };
    this.getSeminarSummaryList = this.getSeminarSummaryList.bind(this);
  }

  componentDidMount() {
    this.getSeminarSummaryList();
  }

  getSeminarSummaryList() {
    this.setState({ isLoading: true });
    this.props
      .getAdminSeminarSummaryList_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("Seminar Summary Data ------->", data.data);
          this.setState({
            isLoading: false,
            seminarSummaryList: data.data.seminarWiseSummary || [],
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  seminarRecord(list) {
    if (!list || list.length === 0) {
      return (
        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
          <tbody>
            <tr>
              <td colSpan={8} style={{ textAlign: "center" }}>
                Record not found
              </td>
            </tr>
          </tbody>
        </table>
      );
    }

    const numCols = [
      "PaidVisitor",
      // "UnPaidVisitor",
      "PaidExhibitor",
      // "UnPaidExhibitor",
      "PaidDelegate",
      // "UnPaidDelegate",
    ];

    const totals = numCols.reduce((acc, col) => {
      acc[col] = list.reduce((sum, row) => sum + (Number(row[col]) || 0), 0);
      return acc;
    }, {});
    const grandTotal = numCols.reduce((sum, col) => sum + totals[col], 0);

    return (
      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
        <thead>
          <tr>
            <th className="text-center" colSpan={8}>
              India ITME 2026 Seminar Wise Visitor Summary as on date
            </th>
          </tr>
          <tr>
            <th className="text-center" rowSpan={2}>Sr No</th>
            <th className="text-center" rowSpan={2}>Date</th>
            <th className="text-center" rowSpan={2}>Time</th>
            <th className="text-center" rowSpan={2}>Seminar</th>
            <th className="text-center">Visitor</th>
            <th className="text-center">Exhibitor</th>
            <th className="text-center">Delegate</th>
            <th className="text-center" rowSpan={2}>Total</th>
          </tr>
          <tr>
            <th className="text-center">Paid</th>
            {/* <th className="text-center">Unpaid</th> */}
            <th className="text-center">Paid</th>
            {/* <th className="text-center">Unpaid</th> */}
            <th className="text-center">Paid</th>
            {/* <th className="text-center">Unpaid</th> */}
          </tr>
        </thead>
        <tbody>
          {list.map((row, i) => {
            const rowTotal = numCols.reduce((sum, col) => sum + (Number(row[col]) || 0), 0);
            return (
              <tr key={i}>
                <td className="text-center">{i + 1}</td>
                <td className="text-center">{row.SeminarDate}</td>
                <td className="text-center">{row.SeminarTime}</td>
                <td>{row.SeminarName}</td>
                <td className="text-center">{row.PaidVisitor}</td>
                {/* <td className="text-center">{row.UnPaidVisitor}</td> */}
                <td className="text-center">{row.PaidExhibitor}</td>
                {/* <td className="text-center">{row.UnPaidExhibitor}</td> */}
                <td className="text-center">{row.PaidDelegate}</td>
                {/* <td className="text-center">{row.UnPaidDelegate}</td> */}
                <td className="text-center">{rowTotal}</td>
              </tr>
            );
          })}
          <tr>
            <td className="text-center" colSpan={4}><strong>TOTAL</strong></td>
            {numCols.map((col) => (
              <td key={col} className="text-center"><strong>{totals[col]}</strong></td>
            ))}
            <td className="text-center"><strong>{grandTotal}</strong></td>
          </tr>
        </tbody>
      </table>
    );
  }

  render() {
    const { isLoading, seminarSummaryList } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <>
          <AdminDrawer />
          <div className="admin-top-space">
            <div className="row mt-2 m-0">
              <div className="table-responsive mb-3 mt-2">
                {this.seminarRecord(seminarSummaryList)}
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getAdminSeminarSummaryList_action,
  })(ConferenceSummary),
);
